module.exports = __webpack_public_path__ + "static/media/business14.e5f0ea82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/business14.jpg
// module id = 94
// module chunks = 0